export const formatToLocalDateTime = (isoString: string): string => {
  if (!isoString) return "-";
  const date = new Date(isoString);
  return date.toLocaleString();
};
